import { SITE } from "../data/site";

export const waLink = (message) =>
    `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

/* Strip control characters, trim, and cap the length — mirrors what the
   old server-side compose endpoint did, now done in the browser. */
const clean = (value, max) =>
    String(value || "")
        // eslint-disable-next-line no-control-regex
        .replace(/[\x00-\x08\x0b\x0c\x0e-\x1f]/g, "")
        .trim()
        .slice(0, max);

/* Builds the pre-filled WhatsApp message for the Business Scan form. */
export const composeScanMessage = (form) => {
    const name = clean(form.name, 80);
    const businessName = clean(form.business_name, 120);
    const businessType = clean(form.business_type, 80);
    const phone = clean(form.phone, 20);
    const challenge = clean(form.challenge, 120);
    const message = clean(form.message, 1000);

    const lines = [`Hi 033 Digital! I'm ${name}.`];
    if (businessName) {
        let line = `My business: ${businessName}`;
        if (businessType) line += ` (${businessType})`;
        lines.push(`${line}.`);
    } else if (businessType) {
        lines.push(`Business type: ${businessType}.`);
    }
    if (phone) lines.push(`You can reach me on: ${phone}.`);
    if (challenge) lines.push(`My main challenge right now: ${challenge}.`);
    if (message) lines.push(`Details: ${message}`);
    lines.push("I'd like to get my business scanned.");

    return lines.join("\n");
};
